<template>
  <div id="app">
    <div class="banner">
    </div>
    <router-view/>
    <div class="footer" v-if="footerShow">© Keysight Technologies 2000-2019</div>
  </div>
</template>
<script>
  export default{
      name:'app',
      data(){
         return {
             footerShow:!/Android|webOS|iPhone|iPod|BlackBerry|ios|iPad/i.test(navigator.userAgent)
         }
      }
  }
</script>
<style lang="scss">
  body{background:#fff;}
  input[type=button], input[type=submit],button,input { cursor: pointer; -webkit-appearance: none;}
  *{margin:0;padding:0;box-sizing:border-box;}
  ul,li{list-style: none;}
  a{text-decoration:none;out-line:none;color:#e8202f}
  input,button,select,textarea{ outline:none;}
  input::-webkit-input-placeholder { /* WebKit browsers */
    color: #bcbcbc;
    font-size: 14px;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #bcbcbc;
    font-size: 14px;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #bcbcbc;
    font-size: 14px;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #bcbcbc;
    font-size: 14px;
  }
  .btn{
    background-color:#e8202f;
    text-align:center;
    border:0px;
    color:#fff;
    border-radius:3px;
    cursor:pointer;
  }
.banner{
  width:1200px;
  height:176px;
  margin:0 auto;
  background: url("assets/img/banner.png") no-repeat center;
}
  .footer{
    width:100%;
    height:60px;
    background-color:#f6f5f6;
    line-height:60px;
    color:#282828;
    text-align:center;
  }
  @media (max-width:768px){
    .banner{
      width:7.5rem;
      height:1.74rem;
      margin:0 auto;
      background: url("assets/img/banner_wap.png") no-repeat center;
      background-size:7.5rem 1.74rem;
    }
    input::-webkit-input-placeholder { /* WebKit browsers */
      font-size: 0.22rem;
    }
    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 0.22rem;
    }
    input::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 0.22rem;
    }
    input:-ms-input-placeholder { /* Internet Explorer 10+ */
      font-size: 0.22rem;
    }
  }
</style>
